import {TTypographyColor, TTypographyVariant, Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';
import classNames from 'classnames';
import {IMetroStation} from 'modules/wineshops-list/models';
import Icon from 'components/Icon';

interface IProps {
    className?: string;
    isSimpleView?: boolean;
    nameTextVariant?: TTypographyVariant;
    nameTextColor?: TTypographyColor;
    walkingTime?: string;
    walkingTimeVariant?: TTypographyVariant;
}

export const MetroStationWalkingTime: FC<Omit<IMetroStation, 'latitude' | 'longitude'> & IProps> = ({
    className,
    hexColor,
    name,
    isSimpleView = false,
    nameTextVariant = 'p-strong',
    nameTextColor = 'gray60',
    walkingTime,
    walkingTimeVariant = 'p',
}) => {
    return (
        <div className={classNames(style.container, className)}>
            <div>
                <div
                    className={classNames(style.metroColor, 'metrostation-color')}
                    style={{backgroundColor: `#${hexColor}`}}
                />
                <Typography
                    className={classNames(style.stationName, 'metrostation-name')}
                    color={nameTextColor}
                    variant={nameTextVariant}
                >
                    {name}
                </Typography>
            </div>
            {!isSimpleView && walkingTime && (
                <div className={classNames(style.walkingTime, 'walking-area')}>
                    <Icon className={classNames(style.human, 'human-icon')} icon={'walking-human'} />
                    <Typography variant={walkingTimeVariant}>{walkingTime}</Typography>
                </div>
            )}
        </div>
    );
};
